import React from "react";
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";

export const manualCloseReasonError = (reason) =>
  String(reason || "").trim() ? "" : "Close Reason is required.";

export default function ManualCloseFollowupDialog({
  open,
  status,
  reason,
  error = "",
  saving = false,
  onStatusChange,
  onReasonChange,
  onCancel,
  onConfirm,
}) {
  const close = () => {
    if (!saving) onCancel?.();
  };

  return (
    <Dialog open={Boolean(open)} onClose={close} className="relative z-[70]">
      <DialogBackdrop className="fixed inset-0 bg-black/45" />
      <div className="fixed inset-0 overflow-y-auto p-4 sm:p-6">
        <div className="flex min-h-full items-start justify-center sm:items-center">
          <DialogPanel className="my-auto max-h-[calc(100vh-2rem)] w-full max-w-2xl overflow-y-auto rounded-2xl bg-white p-5 shadow-2xl sm:p-6">
            <DialogTitle className="text-lg font-semibold text-slate-900">
              Manual Close Follow-up
            </DialogTitle>
            <p id="manual-close-description" className="mt-2 text-sm text-slate-600">
              Manual Close only closes this follow-up. It does not modify iLS orders or release routing correction protection.
            </p>
            <form
              className="mt-5 space-y-4"
              aria-describedby="manual-close-description"
              onSubmit={(event) => {
                event.preventDefault();
                if (!saving) onConfirm?.();
              }}
            >
              <label className="block text-xs font-semibold uppercase tracking-wide text-slate-500">
                Close As
                <select
                  aria-label="Close As"
                  value={status}
                  onChange={(event) => onStatusChange?.(event.target.value)}
                  disabled={saving}
                  className="mt-1 w-full rounded border border-slate-300 px-3 py-2 text-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500 disabled:cursor-not-allowed disabled:bg-slate-100"
                >
                  <option value="DONE">Done</option>
                  <option value="NOT_REQUIRED">No Further Reminder</option>
                </select>
              </label>
              <label className="block text-xs font-semibold uppercase tracking-wide text-slate-500">
                Close Reason
                <textarea
                  aria-label="Close Reason"
                  aria-required="true"
                  autoFocus
                  value={reason}
                  onChange={(event) => onReasonChange?.(event.target.value)}
                  rows={4}
                  disabled={saving}
                  className="mt-1 w-full resize-y rounded border border-slate-300 px-3 py-2 text-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500 disabled:cursor-not-allowed disabled:bg-slate-100"
                  placeholder="Manual close requires a reason."
                />
              </label>
              {error ? (
                <p role="alert" className="text-sm text-red-600">
                  {error}
                </p>
              ) : (
                <p className="text-xs text-slate-500">
                  Manual Close stays secondary and always requires a reason.
                </p>
              )}
              <div className="flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
                <button
                  type="button"
                  onClick={close}
                  disabled={saving}
                  className="rounded border border-slate-300 px-4 py-2 text-sm text-slate-700 hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-60"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={saving}
                  className="rounded bg-slate-900 px-4 py-2 text-sm font-semibold text-white hover:bg-slate-800 disabled:cursor-not-allowed disabled:opacity-60"
                >
                  {saving ? "Closing..." : "Confirm Manual Close"}
                </button>
              </div>
            </form>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
}
